import React from 'react';
import { Grid } from '@mui/material';

import { InfoField } from '@occc-app/design-system';
import { AwardBuyAndGetFragment } from '@occc/graphql';

interface IBuyAndGetAwardProps {
  award: AwardBuyAndGetFragment;
}

export const BuyAndGetAward: React.FC<IBuyAndGetAwardProps> = ({ award }) => {
  return (
    <Grid container spacing={2}>
      <Grid item sm={3}>
        <InfoField label='Discount Threshold' value={award?.discountThreshold} />
      </Grid>
      <Grid item sm={3}>
        <InfoField label='Percent Discount' value={award?.percentDiscount} />
      </Grid>
    </Grid>
  );
};
